import axios from "axios";
import sessionService from "../services/sessionService";

const adminRoles = ["CASH", "CASC", "BSC"];
const customerRoles = ["CSA", "PRO"];

const instance = axios.create({
  baseURL: "/api",
});

instance.interceptors.request.use((config) => {
  config.headers.Pragma = "no-cache";
  config.metadata = { startTime: new Date() };
  config.maxContentLength = Infinity;
  config.maxBodyLength = Infinity;

  var auth = sessionService.getAuthorization();

  if (auth) config.headers.authorization = `Bearer ${auth}`;

  config.headers["x-country-code"] = sessionService.getUser().countryCode;
  config.headers["x-channel-id"] = getChannel();
  config.headers["x-b3-spanid"] = "43e597f831af1c72";
  config.headers["x-b3-traceid"] = "31af1c727c2bc4ab";
  config.headers["x-user-context"] =
    sessionService.getUser().username !== undefined ? getUserContext() : "";
  config.headers["x-time-zone"] =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  config.headers["accept-language"] = sessionService.getLanguage();

  return config;
});

instance.interceptors.response.use((response) => {
  response.config.metadata.endTime = new Date();
  response.duration =
    response.config.metadata.endTime - response.config.metadata.startTime;

  return response;
});

export const getUserContext = () => {
  var userContext = getContextObj();
  var user = sessionService.getUser();

  switch (user.userType) {
    case "CSA":
      userContext.customer.id = user.username;
      userContext.consumer.consumer_type = "customer";
      break;
    case "PRO":
      userContext.supplier.id = user.username;
      userContext.consumer.consumer_type = "supplier";
      break;
    case "BSC":
      userContext.staff.id = user.username;
      userContext.consumer.consumer_type = "staff";
      break;
    default:
      break;
  }

  userContext.consumer.consumer_user = user.username;

  return btoa(JSON.stringify(userContext));
};

export const getContextObj = () => {
  return {
    country_code: sessionService.getUser().countryCode,
    channel_id: getChannel(),
    sub_channel: "REVERFACT",
    language: "es_CR",
    customer: {
      id: "",
      card_number: "",
    },
    supplier: {
      id: "",
    },
    staff: {
      id: "",
      teller_number: "",
      source_transit: "",
      domicile_transit: "",
    },
    consumer: {
      consumer_user: "",
      consumer_type: "",
      ip_address: "",
    },
  };
};

export const getChannel = () => {
  var userType = sessionService.getUser().userType;
  return customerRoles.includes(userType)
    ? "Online"
    : adminRoles.includes(userType)
    ? "BackOffice"
    : "";
};

// const genRanHex = (size) => {
//     return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
// }

export default instance;
